import { Component, computed } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { BaseInputComponent, HelpTextDirective, ValidatorMessageDirective, controlProvider } from 'superlikers-dynamic-forms'

/**
 * Custom control type registered under CUSTOM_CONTROLS as 'textarea'.
 * superlikers-dynamic-forms has no native multi-line text control, so this
 * mirrors its own InputFieldComponent but renders a <textarea>.
 */
@Component({
  selector: 'app-textarea-field',
  imports: [ReactiveFormsModule, HelpTextDirective, ValidatorMessageDirective],
  viewProviders: [controlProvider],
  templateUrl: './textarea-field.html'
})
export class TextareaField extends BaseInputComponent {
  placeholder = computed(() => this.control().placeholder ?? '')
}
